$(function () {
  // Sticky Add to cart
  $(".sticky__cart_addtocart").on("click", function (e) {
    e.preventDefault();
    $(".product-form__buttons .product-form__submit.ctm_trigger_btn").trigger(
      "click"
    );
    return false;
  });
  $(window)
    .on("scroll", () => {
      $("product-form").each(function () {
        //var className = $(this).attr("touching")
        var offset = $(this).offset().top - $(window).scrollTop() + 70;
        if (offset <= 0) {
          $("body").addClass("fixed-cart");
        } else {
          $("body").removeClass("fixed-cart");
        }
      });
    })
    .trigger("scroll");
  $(".span_arrow").click(function () {
    $(this).next().slideToggle("slow");
    $(this).next().css("display", "flex");
    $(this).toggleClass("up");
  });
  // Copy Promo code
  function copy() {
    let copyText = document.getElementById("copyClipboard");
    let copySuccess = document.getElementById("copied-success");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);

    copySuccess.style.display = "block";
    setTimeout(function () {
      copySuccess.style.display = "none";
    }, 500);
  }

  function subscription() {
    var id = $('[name="id"]').val();
    var discount_price = $(
      '.ctm_widget .main_selector [data-id="' + id + '"]'
    ).data("discount-price");
    var price = $('.ctm_widget .main_selector [data-id="' + id + '"]').data(
      "price"
    );

    $(".subscribe_save .product_subscription_price .reg_price").html(price);
    $(".subscribe_save .product_subscription_price .sale_price").html(
      discount_price
    );
    $(".one_time .product_subscription_price .sale_price").html(price);
  }

  //custom js vivek
  const pathname = window.location.pathname;
// if (pathname.includes("/products/replacement-filter")) {
 // if (!pathname.includes("/products/shower-filter") &&   !pathname.includes("/products/filtered-showerhead")) {
if (!pathname.includes("/products/shower-filter") &&   !pathname.includes("/products/filtered-showerhead") && !pathname.includes("/products/showerhead-sale")) {
$(".product-form__buttons .ctm_trigger_btn").on("click", function (e) {
    e.preventDefault();
    if($('.subscribe_save.active').length == 0){

        var final_val = undefined;
        $('variant-radios fieldset .swatch_item :radio:checked').each(function(i,e) {
           var val = $(this).val();
           if(i == 0){
            final_val = val;   
           }else{
            final_val += ' / '  + val;
           } 
        })
        
        console.log(final_val)
        if(final_val == undefined){
          $('.product_subscription_custom .main_product_variants .variants').each(function(i,e) {
             if(i == 0){
               var id = $(this).data('id');
               console.log(id); 
               $(this).closest('.product__info-wrapper').find('[name="id"]').val(id);  
             } 
          })
        }else{       
          $('.product_subscription_custom .main_product_variants .variants').each(function(e) {
             var title = $(this).data('title');
             if(title == final_val){
               var id = $(this).data('id');
               console.log(id); 
               $(this).closest('.product__info-wrapper').find('[name="id"]').val(id);  
             } 
          })
        }
      
      if($('.ctm_subscription-product.filter_product').length > 0){
        //$(this).closest('form').find('.subscription_properties').attr('name','properties[Without Subscription]').val('yess');          
         $('.ctm_selling_plan').attr('name','').val();
        $('.product-form__buttons .ctm_main_product').trigger('click');    
      }else{
        $(this).closest('form').find('.subscription_properties').attr('name','');  
        $('.product-form__buttons .ctm_main_product').trigger('click');  
      }
    }else{
      
       var final_val = undefined;
      $('variant-radios fieldset .swatch_item :radio:checked').each(function(i,e) {
         var val = $(this).val();
         if(i == 0){
          final_val = val;   
         }else{
          final_val += ' / '  + val;
         } 
      })
      
      console.log(final_val)
      if(final_val == undefined){
        $('.product_subscription_custom .main_prod_dropdown .variants').each(function(i,e) {
           if(i == 0){
             var id = $(this).data('id');
             console.log(id); 
             $(this).closest('.product__info-wrapper').find('[name="id"]').val(id);  
           } 
        })
      }else{
       if($('.product_subscription_item.subscribe_save.active').length > 0){          
          $('.product_subscription_custom .main_prod_dropdown .variants').each(function(e) {
             var title = $(this).data('title');
             if(title == final_val){
               var id = $(this).data('id');
               console.log(id); 
               $(this).closest('.product__info-wrapper').find('[name="id"]').val(id);  
             } 
          })
        } 
      }
      
      if($('.ctm_subscription-product.filter_product').length > 0){
          var sub_id = $(this).closest('product-info').find('[name="id"]').val();
          var plan_name = $(this).closest('product-info').find('.ctm_subscription-product .ctm_widget [data-id="'+sub_id+'"]').attr('data-plan-name');
        console.log(plan_name);
          $(this).closest('form').find('.subscription_properties').attr('name','properties[With Subscription]').val(plan_name);  
          var selling_plan = $(this).closest('product-info').find('.ctm_subscription-product .ctm_widget [data-id="'+sub_id+'"]').attr('data-selling-id');
          $('.ctm_selling_plan').attr('name','selling_plan').val(selling_plan);
          $('.product-form__buttons .ctm_main_product').trigger('click');   
         
      }else{
        $(this).closest('form').find('.subscription_properties').attr('name','properties[Billed]');  
        var sub_id = $(this).closest('product-info').find('.ctm_subscription-product .ctm_widget').data('id');
        var selling_plan = $(this).closest('product-info').find('.ctm_subscription-product .ctm_widget [data-id="'+sub_id+'"]').attr('data-selling-id');
        var plan_name = $(this).closest('product-info').find('.ctm_subscription-product .ctm_widget [data-id="'+sub_id+'"]').attr('data-plan-name');  
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data:{
           id: sub_id,
           quantity: 1,
           selling_plan: selling_plan,
           properties: {
              "Billed": plan_name  
            }  
           },
           dataType: "json",
           success: function(data) {
            console.log(data);  
            $('.product-form__buttons .ctm_main_product').trigger('click');   
           },
           error: function(err) {
             console.log(err);  
             $('.product-form__buttons .ctm_main_product').trigger('click');  
           }  
         })   
      }   
    }
    return false; 
  })
}
  //end running js

  else {
  $(".product-form__buttons .ctm_trigger_btn").on("click", function (e) {
    e.preventDefault();
    if ($(".subscribe_save.active").length == 0) {
      console.log("one_time.active ");
      // added by vivek - 5 June
      $(this)
        .closest(".product__info-wrapper")
        .find('[name="selling_plan"]')
        .attr("name", "without_selling_plan"); //remove selling plan

      let variant = $("variant-selects fieldset input:radio:checked").val();
      let variantID = $(".for-single-product").find(`input[name="${variant}"]`).val();
 let productID = $(this).closest(".product__info-wrapper").data("product-id"); // Ensure this data attribute is set
// if (!variantID) {
//   variantID = productID; // Fallback to product ID if no variant
// }
      $(this).closest(".product__info-wrapper").find('[name="id"]').val(variantID);
      //$(this).closest(".product__info-wrapper").find('[name="product-id"]').val();

      if ($(".ctm_subscription-product.filter_product").length > 0) {
      
          $(this).closest("form").find(".subscription_properties").attr("name", "properties[Without Subscription]").val('yes');
          $(".ctm_selling_plan").attr("name", "").val();
         
          $(".product-form__buttons .ctm_main_product").trigger("click");
          
      }else {
        $(this).closest("form").find(".subscription_properties").attr("name", "");
        $(".product-form__buttons .ctm_main_product").trigger("click");
      }
    } else {
      console.log("**********subscription plan********");
      // add selling plan if removed
      $(this).closest(".product__info-wrapper").find('[name="without_selling_plan"]').attr("name", "selling_plan");

      var final_val = undefined;
      $("variant-selects fieldset input:radio:checked").each(function (i, e) {
        var val = $(this).val();
        if (i == 0) {
          final_val = val;
        } else {
          final_val += " / " + val;
        }
      });

      if (final_val == undefined) {
        $(".product_subscription_custom .main_prod_dropdown .variants").each(
          function (i, e) {
            if (i == 0) {
              var id = $(this).data("id");
              console.log(id);
              $(this)
                .closest(".product__info-wrapper")
                .find('[name="id"]')
                .val(id);
            }
          }
        );
      } else {
        if ($(".product_subscription_item.subscribe_save.active").length > 0) {
          $(".product_subscription_custom .main_prod_dropdown .variants").each(
            function (e) {
              var title = $(this).data("title");
              if (title == final_val) {
                var id = $(this).data("id");
                console.log(id);
                $(this)
                  .closest(".product__info-wrapper")
                  .find('[name="id"]')
                  .val(id);
              }
            }
          );
        }
      }

      if ($(".ctm_subscription-product.filter_product").length > 0) {
        var sub_id = $(this).closest("product-info").find('[name="id"]').val();
        var plan_name = $(this)
          .closest("product-info")
          .find(
            '.ctm_subscription-product .ctm_widget [data-id="' + sub_id + '"]'
          )
          .attr("data-plan-name");
        console.log(plan_name);
        $(this)
          .closest("form")
          .find(".subscription_properties")
          .attr("name", "properties[With Subscription]")
          .val(plan_name);
        var selling_plan = $(this)
          .closest("product-info")
          .find(
            '.ctm_subscription-product .ctm_widget [data-id="' + sub_id + '"]'
          )
          .attr("data-selling-id");
        $(".ctm_selling_plan").attr("name", "selling_plan").val(selling_plan);
        $(".product-form__buttons .ctm_main_product").trigger("click");
      } else {
        $(this)
          .closest("form")
          .find(".subscription_properties")
          .attr("name", "properties[Billed]");
        var sub_id = $(this)
          .closest("product-info")
          .find(".ctm_subscription-product .ctm_widget")
          .data("id");
        var selling_plan = $(this)
          .closest("product-info")
          .find(
            '.ctm_subscription-product .ctm_widget [data-id="' + sub_id + '"]'
          )
          .attr("data-selling-id");
        var plan_name = $(this)
          .closest("product-info")
          .find(
            '.ctm_subscription-product .ctm_widget [data-id="' + sub_id + '"]'
          )
          .attr("data-plan-name");
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data: {
            id: sub_id,
            quantity: 1,
            selling_plan: selling_plan,
            properties: {
              Billed: plan_name,
            },
          },
          dataType: "json",
          success: function (data) {
            console.log(data);
            $(".product-form__buttons .ctm_main_product").trigger("click");
          },
          error: function (err) {
            console.log(err);
            $(".product-form__buttons .ctm_main_product").trigger("click");
          },
        });
      }
    }
    return false;
  });

}

  $(".product_subscription_custom .product_subscription_item").on(
    "click",
    function (e) {
      e.preventDefault();
      $(this)
        .closest(".product_subscription_custom")
        .find(".active")
        .removeClass("active");
      $(this).addClass("active");
      if ($(this).hasClass("subscribe_save")) {
        $(".rc-widget .rc-template__radio .subscription-radio").trigger(
          "click"
        );
      } else {
        $(".rc-widget .rc-template__radio .onetime-radio").trigger("click");
      }
      return false;
    }
  );

  document.querySelectorAll("[data-multirow-progress]").forEach(function (section) {
      const i = section.querySelector(
        ".multirow__inner-progress"
      ).parentElement;
      const t = section.querySelector(".multirow__inner-progress");
      let n = 0;
      window.addEventListener("scroll", function () {
        let e = window.innerHeight;
        const o = i.getBoundingClientRect();
        !t ||
          (o.top < e &&
            n <= 130 &&
            (n = Math.round((100 * (e - o.top)) / o.height)),
          n > 130 && (n = 130),
          (t.style.height = `calc(${n}% - 300px)`));
      });
      window.addEventListener("resize", function () {
        let e = window.innerHeight;
        const o = i.getBoundingClientRect();
        !t ||
          (o.top < e &&
            n <= 130 &&
            (n = Math.round((100 * (e - o.top)) / o.height)),
          n > 130 && (n = 130),
          (t.style.height = `calc(${n}% - 300px)`));
      });
    });

  // Replay footer animation when user reaches at bottom
  $(".shopify-section-group-footer-group .animate--slide-in").css(
    "animation",
    "none"
  );
  $(window).scroll(function () {
    var bodyBottom =
      $("body").outerHeight() -
      $(".shopify-section-group-footer-group").outerHeight() -
      $(window).outerHeight();
    var scrollTop = $(window).scrollTop() - 250;
    if (scrollTop > bodyBottom) {
      setTimeout(function () {
        $(".shopify-section-group-footer-group .animate--slide-in").css(
          "animation",
          "var(--animation-slide-in)"
        );
      }, 100);
    }
  });

  $(document).on("click",'.cart_upsell_product .upsell_data [type="submit"]',function (e) {
      e.preventDefault();
      var remove_prod_id = $(this).data("remove-prod");
      var _prod_id = $(this).data("remove-prod-id");
      var qty = parseInt(
        $("cart-drawer-items")
          .find(
            '.cart-items [data-prod-id="' +
              _prod_id +
              '"] .cart-item__quantity .quantity__input'
          )
          .val()
      );
      var sub_id = $(this)
        .closest("cart-drawer-items")
        .find(".ctm_subscription-product .ctm_widget")
        .data("id");
      var selling_plan = $(this)
        .closest("cart-drawer-items")
        .find(
          '.ctm_subscription-product .ctm_widget [data-id="' + sub_id + '"]'
        )
        .attr("data-selling-id");
      var plan_name = $(this)
        .closest("cart-drawer-items")
        .find(
          '.ctm_subscription-product .ctm_widget [data-id="' + sub_id + '"]'
        )
        .attr("data-plan-name");
      var main_prod_id = $(this).data("main_product");
      // var main_prod_selling_id = $(this).closest('cart-drawer-items').find('.ctm_subscription-product .main_selector').data('main-selling-plan');
      var _this = $(this);
      console.log("quantity: ", qty);
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: {
          id: sub_id,
          quantity: qty,
          selling_plan: selling_plan,
          properties: {
            Billed: plan_name,
          },
        },
        dataType: "json",
        success: function (data) {
          console.log(data);
          $.ajax({
            type: "post",
            url: "/cart/add.js",
            data: {
              id: main_prod_id,
              quantity: qty,
              // selling_plan:main_prod_selling_id,
              properties: {
                Billed: "No",
              },
            },
            dataType: "json",
            success: function (data) {
              console.log(data);
              $.ajax({
                type: "post",
                url: "/cart/change.js",
                data: {
                  id: remove_prod_id,
                  quantity: 0,
                },
                success: function (data) {
                  console.log("cart_upsell_product initial..");
                  fetch(`${routes.cart_url}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const html = new DOMParser().parseFromString(
                        responseText,
                        "text/html"
                      );
                      const sourceQty = html.querySelector(".drawer__inner");
                      document.querySelector(".drawer__inner").innerHTML =
                        sourceQty.innerHTML;
                      setTimeout(function (e) {
                        cookieStore.get("qty_left").then(function (e) {
                          console.log(e);
                          if (e != null) {
                            $(".ctm_count").text(e.value);
                            $(".ctm_count").show();
                          }
                        });
                      }, 500);
                      //  Show the upsell section here
                      console.log("cart_upsell_product");
                      // $('.cart_upsell_product').fadeIn();
                    })
                    .catch((e) => {
                      console.error(e);
                    });
                },
                error: function (err) {
                  console.log(err);
                },
              });
            },
            error: function (err) {
              console.log(err);
            },
          });
        },
        error: function (err) {
          console.log(err);
        },
      });
      return false;
    }
  );

  setTimeout(function () {
    $(".fade-image").addClass("loaded");
  }, 250);
});


